import { render, staticRenderFns } from "./PagePagination.vue?vue&type=template&id=450c63a0&lang=pug&"
import script from "./PagePagination.vue?vue&type=script&lang=ts&"
export * from "./PagePagination.vue?vue&type=script&lang=ts&"
import style0 from "./PagePagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports